import { render } from "./RedCouponPopover.vue?vue&type=template&id=2acb2c22&scoped=true"
import script from "./RedCouponPopover.vue?vue&type=script&lang=js"
export * from "./RedCouponPopover.vue?vue&type=script&lang=js"

import "./RedCouponPopover.vue?vue&type=style&index=0&id=2acb2c22&lang=scss&scoped=true"

import exportComponent from "/root/workspace/bjyx-h5_Pbc0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acb2c22"]])

export default __exports__